import * as React from "react";
import {
  WidgetFrame,
  ProgressWidget,
  ErrataView,
  FormJSON,
} from "../../../personal-studio-components/studio";
import { Icon, TextCard } from "../../../personal-studio-components/studio";
import { Dialog } from "../../../personal-studio-components/component/Dialog.jsx";
// eslint-disable-next-line no-unused-vars
import { ChatRoomModel } from "./ChatRoomModel.js";
import imageIcon from "../../resources/images/image-png.png";
import pdfIcon from "../../resources/images/application-pdf-small.png";
import * as cls from "./ChatRoom.module.scss";
export { ChatRoomView };
/**
 * Вид диалога "Чатрум" на странице "Консультации".
 * @param {Object} props - Атрибуты компонента.
 * @param {ChatRoomModel} props.model - Модель страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ChatRoomView({
  model,
  progress,
  student_service_url,
  errorFiles,
  setErrorFiles,
}) {
  const schema = model.getSchema();
  const messages = model.messages.map((message) => (
    <ChatRoomView.MessageView
      student_service_url={student_service_url}
      key={message.question_message_id}
      message={message}
    />
  ));
  return (
    <Dialog
      title={model.title}
      open={true}
      onClose={(e) => {
        model.onClose(e);
        setErrorFiles(null);
      }}
    >
      {messages}

      <FormJSON
        schema={schema}
        progress={progress}
        errorFiles={errorFiles}
        setErrorFiles={setErrorFiles}
      />
    </Dialog>
  );
}
/**
 * Вид сообщения в чатруме.
 * @param {Object} props - Атрибуты компонента.
 * @param {ChatRoomModel~Message} props.message - Сообщение.
 * @returns {JSX.Element} Элемент JSX.
 */
ChatRoomView.MessageView = ({ message, student_service_url }) => {
  return (
    <TextCard
      type={message.is_answer ? "primary" : "default"}
      className={message.is_answer ? cls.left_message : cls.right_message}
    >
      <div className={cls.message_date}>
        {new Date(message.sys_time_creation).toLocaleDateString()}
      </div>
      <p dangerouslySetInnerHTML={{ __html: message.text }}></p>
      {message.attachments && (
        <div style={{ marginTop: " 10px" }}>
          <h4 style={{ marginBottom: "5px" }}>Вложения:</h4>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {message.attachments.map((attachment) => {
              const index = attachment.url.indexOf("question_tutor");
              const slicedUrl = attachment.url.slice(index);
              const url = student_service_url + "/" + slicedUrl;
              const fileExtension = attachment.filename
                .split(".")
                .pop()
                .toLowerCase();
              return (
                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "10px" }}>
                    <img
                      style={{ height: 20 }}
                      src={fileExtension === "pdf" ? pdfIcon : imageIcon}
                    />
                  </div>
                  <a
                    href={url}
                    style={{
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={attachment.filename}
                    target="_blank"
                  >
                    {attachment.filename}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </TextCard>
  );
};

/**
 * Вид загрузчика страницы.
 * @param {Object} props - Атрибуты компонента.
 * @param {string} props.title - Заголовок диалога.
 * @param {function} props.onClose - Действие при закрытии диалога.
 * @returns {JSX.Element} Элемент JSX.
 */
ChatRoomView.LoaderView = ({ title, onClose }) => (
  <Dialog title={title} open={true} onClose={onClose}>
    <p>
      <Icon name="loading" /> Загрузка сообщений...
    </p>
  </Dialog>
);
/**
 * Вид отчёта об ошибке загрузки страницы.
 * @param {Object} props - Атрибуты компонента.
 * @param {string} props.title - Заголовок диалога.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @param {function} props.onClose - Действие при закрытии диалога.
 * @returns {JSX.Element} Элемент JSX.
 */
ChatRoomView.ErrataView = ({ title, errata, onClose }) => (
  <Dialog title={title} open={true} onClose={onClose}>
    <ErrataView errata={errata} />
  </Dialog>
);
